if (!customElements.get('variant-selector')) {
  class VariantSelector extends HTMLElement {
    constructor() {
      super();
      this._isLoading = false;
      this._currentVariantId = null;
    }

    connectedCallback() {
      this._currentVariantId = parseInt(this.getAttribute('current-variant-id'), 10);
      this._productUrl = this.getAttribute('product-url');
      this._sectionId = this.getAttribute('section-id') || 'product-main';

      this.addEventListener('change', (e) => {
        if (e.target.name !== 'variant-selector') return;
        this._selectVariant(parseInt(e.target.value, 10));
      });
    }

    async _selectVariant(variantId) {
      if (variantId === this._currentVariantId || this._isLoading) return;

      this._isLoading = true;
      this._currentVariantId = variantId;

      this.querySelectorAll('label').forEach(label => {
        const radio = label.querySelector('input[type="radio"]');
        if (!radio) return;
        const isActive = parseInt(radio.value, 10) === variantId;
        radio.checked = isActive;
        label.classList.toggle('bg-grey-600', isActive);
        label.classList.toggle('text-white', isActive);
        label.classList.toggle('border-grey-600', isActive);
        label.classList.toggle('bg-white', !isActive);
        label.classList.toggle('text-grey-600', !isActive);
        label.classList.toggle('border-grey-100', !isActive);
        label.classList.toggle('hover:border-grey-600', !isActive);
      });

      const currentLabel = this.querySelector('[data-variant-current]');
      if (currentLabel) {
        const radio = this.querySelector(`input[value="${variantId}"]`);
        if (radio) currentLabel.textContent = radio.closest('label').textContent.trim();
      }

      // Show loading overlay
      const loader = this.querySelector('[data-variant-loading]');
      if (loader) loader.style.display = 'block';

      try {
        const response = await fetch(
          `${this._productUrl}?variant=${variantId}&section_id=${this._sectionId}`
        );

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const newHTML = await response.text();
        const doc = new DOMParser().parseFromString(newHTML, 'text/html');

        const sectionWrapper = document.getElementById(`shopify-section-${this._sectionId}`);
        const newSection = doc.getElementById(`shopify-section-${this._sectionId}`);

        if (sectionWrapper && newSection) {
          sectionWrapper.innerHTML = newSection.innerHTML;
        }

        const url = new URL(window.location);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url);

        window.dispatchEvent(
          new CustomEvent('variant:changed', { detail: { variantId } })
        );

      } catch (err) {
        console.error('variant-selector: Variant switch failed', err);
      }
    }
  }

  customElements.define('variant-selector', VariantSelector);
}
